import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Response, AmagVehicleData} from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class AmagVehicleDataService {

  constructor(private httpClient: HttpClient) { }

  getAmagVehicleDataByCommissionNumber(commissionNumber: string): Observable<Response<AmagVehicleData>> {
    return this.httpClient.get<Response<AmagVehicleData>>(environment.apiPath + 'AmagVehicleData/' + commissionNumber + '/CommissionNumber');
  }
}
